import { RiArrowGoBackFill } from 'react-icons/ri'
import { BsUiChecks, BsClipboardCheck, BsCheck2Circle, BsBootstrapReboot } from 'react-icons/bs'
import { FaList, FaUsers } from 'react-icons/fa'
import { FcDisclaimer, FcApproval } from 'react-icons/fc'
import { MdPostAdd, MdOutlinePropaneTank } from 'react-icons/md'
import { GoPackage } from 'react-icons/go'
import { AiOutlineStop } from 'react-icons/ai'
import { HiDocumentReport } from 'react-icons/hi'
import { HiOutlineClipboardDocumentList } from 'react-icons/hi2'
import { GiMagnifyingGlass } from "react-icons/gi";

export const OrderType = {
  ALL: "ทั้งหมด",
  BULK: "BULK",
  FG: "FG"
}

export const OrderStatusDisplay = {
  PD_READY: 'พร้อมผลิต',
  PD_IN_PROGRESS: 'กำลังผลิต',
  PD_DRAFTED: 'ผลิตจบแล้ว',
  PD_CONFIRMED: 'ยืนยันแล้ว',
  PD_CANCELED: 'ยกเลิก',
  ALL: 'ทั้งหมด'
}

export const OrderStatusDisplayPdLeaderline = {
  ALL: 'ทั้งหมด',
  PD_READY: 'พร้อมผลิต',
  PD_IN_PROGRESS: 'กำลังผลิต',
  PD_DRAFTED: 'ผลิตจบแล้ว'
}

export const OrderStatusDisplayPdAdmin = {
  PD_READY: 'พร้อมผลิต',
  PD_IN_PROGRESS: 'กำลังผลิต',
  PD_DRAFTED: 'ผลิตจบแล้ว รอยืนยัน',
  PD_CONFIRMED: 'ยืนยันแล้ว',
  PD_CANCELED: 'ยกเลิก'
}

export const DefaultOrderStatus = {
  LeaderLines: "PD_READY",
  Leaderline: "PD_READY"
}

export const OrderStatusForAdminDisplay = {
  PD_DRAFTED: 'ผลิตจบแล้ว',
  PD_CONFIRMED: 'ยืนยันแล้ว',
}

export const OrderReasonCodeStatusDisplay = {
  PD_DRAFTED: 'ผลิตจบแล้ว',
  PD_CONFIRMED: 'ยืนยันแล้ว',
}

export const OrderStatusCode = {
  READY: 'PD_READY',
  IN_PROGRESS: 'PD_IN_PROGRESS',
  DRAFTED: 'PD_DRAFTED',
  CONFIRMED: 'PD_CONFIRMED'
}
export const AllowOrderStatus = {
  LeaderLines: [OrderStatusCode.READY, OrderStatusCode.IN_PROGRESS, OrderStatusCode.DRAFTED],
  Leaderline: [OrderStatusCode.READY, OrderStatusCode.IN_PROGRESS, OrderStatusCode.DRAFTED],
  Admins: [OrderStatusCode.DRAFTED, OrderStatusCode.CONFIRMED],
  Admin: [OrderStatusCode.DRAFTED, OrderStatusCode.CONFIRMED]
}

export const OrderStatusTheme = {
  PD_READY: 'outline-primary',
  PD_IN_PROGRESS: 'primary',
  PD_DRAFTED: 'outline-success',
  PD_CONFIRMED: 'success',
  PD_CANCELED: 'secondary'
}

export const MaxOrderSelectedDay = 30

export const ErrorOrderSelectDay = {
  START_DATE_INVALID: 'เลือกวันที่เริ่มไม่ถูกต้อง กรุณาเลือกใหม่',
  END_DATE_INVALID: 'เลือกวันที่จบไม่ถูกต้อง กรุณาเลือกใหม่',
  OUT_OF_SCOPE: `ไม่สามารถจำนวนวันเกิน ${MaxOrderSelectedDay} วันได้`,
}

export const Documents = {
  PRODUCTION_PROCESS: 'Production Process',
  PRODUCTION_PROCESS_CONFIRM: 'ข้อมูลบันทึกการผลิต',
  PRODUCTION_ORDER_PICKLIST: 'Production Order Picklist',
  PRODUCTION_QC_FG: 'ใบตรวจสอบคุณภาพสินค้า'
}

export const UserRoleColor = {
  PD_ADMIN: "admin",
  PD_LEADER_LINE: "leaderline"
}

export const OperationTime = {
  SETUP_TIME: 'Set Up',
  RUN_TIME: 'Run Time',
  DOWN_TIME: 'Down Time',
  SOAP_BASE: 'Soap Base'
}

export const OperationTimeQC = {
  INSPECT_BULK: 'Inspect Bulk'
}

export const LaborTimeType = {
  RT: 'RT',
  OT: 'OT'
}

export const EditSapMasterStatusDisplay = {
  ALL: 'ทั้งหมด',
  EDIT_WC: 'WC',
  EDIT_OPERATION: 'OP'
}

export const EditSapMasterStatusTheme = {
  EDIT_WC: 'warning',
  EDIT_OPERATION: 'info'
}

export const Division = {
  ALL: 'ทั้งหมด',
  HHD: 'HHD-Household',
  TLT: 'TLT-Toiletry'
}

export const DivisionValue = {
  HHD: 'Household',
  TLT: 'Toiletry'
}

export const DivisionTheme = {
  Household: 'warning',
  Toiletry: 'info'
}

export const MainMenu = [
  { title: '1.Batch No', value: 'edit_batch_no'},
	{ title: '2.บันทึกเวลาผลิต', value: 'operation'},
	{ title: '3.เบิกเพิ่ม', value: 'extra' },
	{ title: '4.บันทึกของเสีย', value: 'reason_code'},
	{ title: '5.บันทึกยอดใช้ดี/เสีย', value: 'picklist' },
  { title: '6.สรุป Receipt', value: 'retain_record', isNew: true },
	{ title: '7.Comment', value: 'comment' },
]

export const MainMenuAdmin = [
  { title: '1.Batch No', value: 'edit_batch_no'},
	{ title: '2.ยืนยันข้อมูลเวลาผลิต', value: 'operation'},
	{ title: '3.ยืนยันข้อมูลของเสีย', value: 'reason_code'},
  { title: '4.รายการเบิกเพิ่ม', value: 'extra' },
  { title: '5.ตรวจสอบยอดใช้ดี/เสีย', value: 'picklist' },
  { title: '6.สรุป Receipt', value: 'retain_record', isNew: true },
  { title: '7.Comment', value: 'comment' }
]

export const Shift = [
  "0-Day", "1-กลางวัน", "2-กลางคืน", "3-กลางคืน"
]

export const NavMenus = [
  { 
    title: 'Order พร้อมผลิต',
    path: 'order-ready',
    description: 'Line การผลิตบันทึกเวลาการผลิต',
    logo: BsClipboardCheck, 
    color: ' fill-green-500',
    category: 'order-ready',
    active: true
  },
  { 
    title: 'Order รอการยืนยัน', 
    path: 'order-wait-confirm',
    description: 'PD Admin ตรวจสอบและยืนยัน Order ไปยัง SAP',
    logo: BsClipboardCheck, 
    color: ' fill-green-500',
    category: 'order-wait-confirm',
    active: true
  },
  { 
    title: 'จัดการข้อมูล Order', 
    path: 'master',
    description: 'จัดการข้อมูล Production Order',
    logo: FaList, 
    color: ' fill-blue-500',
    category: 'master',
    active: true
  },
  { 
    title: 'จัดการผู้ใช้งาน', 
    path: 'users',
    description: 'จัดการผู้ใช้งานในระบบ',
    logo: FaUsers, 
    color: ' fill-yellow-500',
    category: 'users',
    active: true
  },
  { title: 'PD - อนุมัติเบิก', path: 'picklist-approve',
    description: 'อนุมัติใบเบิกของ Order ที่ต้องการผลิต ส่งไปยัง Warehouse',
    logo: BsClipboardCheck, color: ' fill-red-500',
    category: 'picklist-approve', active: true },
  { title: 'PD - ตรวจสอบใบเบิก', path: 'picklist-check',
    description: 'ตรวจสอบ RM/PK ที่ส่งมาจาก Warehouse',
    logo: BsUiChecks, color: 'fill-yellow-400',
    category: 'picklist-check', active: true  },
  { title: 'QC - ตรวจสอบ RM ก่อนผสม', path: 'picklist-qa-check',
    description: 'ตรวจสอบ RM ก่อนผสม',
    logo: BsUiChecks, color: 'fill-red-400',
    category: 'picklist-qa-check', active: true  },
  { title: 'PD - ปิด Order', path: 'picklist-complete',
    description: 'ปิดเอกสารใบเบิกที่ผลิตจบแล้ว และอนุมัติคืน',
    logo: BsCheck2Circle, color: 'fill-green-500',
    category: 'picklist-complete', active: true  },
  { title: 'WH - อนุมัติคืน', path: 'picklist-return',
    description: 'ตรวจสอบยอดคืนจาก Production',
    logo: RiArrowGoBackFill, color: 'fill-green-300',
    category: 'picklist-return', active: true  },
  { title: 'PD - อนุมัติเบิกเพิ่ม', path: 'picklist-extra',
    description: 'อนุมัติคำร้องขอเบิกเพิ่มจาก LINE ผลิต ส่งไปยัง Warehouse',
    logo: MdPostAdd, color: ' fill-yellow-500',
    category: 'picklist-extra', active: true  },
  { title: 'รายงาน', path: 'report',
    description: 'รายงาน Production Order',
    logo: HiDocumentReport, color: ' fill-red-500',
    category: 'report', active: true  },
  { title: 'รายการ PD Order ที่มีคืนเสีย PKG', path: 'waste-return',
    description: 'รายการ PD Order ที่มียอด Packaging คืนเสียกลับเข้าคลัง',
    logo: FcDisclaimer, color: ' fill-red-500',
    category: 'waste-return', active: true  },
  { title: 'ใบเบิก', path: 'picklist-detail',
    description: 'ภาพรวม ใบเบิก',
    logo: HiOutlineClipboardDocumentList, color: '',
    category: 'picklist-detail', active: true  },
  { title: 'อนุมัติรายการ QC-Bulk', path: 'bulk-inspection',
    description: 'อนุมัติรายการ QC-Bulk',
    logo: BsUiChecks, color: 'fill-rose-400',
    category: 'bulk-inspection', active: true  },
  { 
    title: 'อนุมัติจ่าย RM',
    description: 'อนุมัติจ่าย RM ไปยัง Order ที่ PD ต้องการ',
    path: 'good-issue-order/bulk',
    category: 'good-issue-order',
    categoryTitle: 'WH - อนุมัติจ่าย',
    logo: MdOutlinePropaneTank, 
    color: 'fill-yellow-300', active: true 
  },
  { 
    title: 'อนุมัติจ่าย PKG',
    description: 'อนุมัติจ่าย PKG ไปยัง Order ที่ PD ต้องการ',
    path: 'good-issue-order/fg',
    category: 'good-issue-order',
    categoryTitle: 'WH - อนุมัติจ่าย',
    logo: GoPackage, 
    color: 'fill-blue-300', active: true 
  },
  { 
    title: 'อนุมัติจ่าย CLAIM',
    path: 'good-issue-order/claim',
    description: 'อนุมัติจ่าย FG ไปยัง Order ที่ PD ต้องการ',
    category: 'good-issue-order',
    categoryTitle: 'WH - อนุมัติจ่าย',
    logo: AiOutlineStop, 
    color: 'fill-red-400', active: true 
  },
  { 
    title: 'อนุมัติจ่าย REPACK',
    path: 'good-issue-order/repack',
    description: 'อนุมัติจ่าย Component ไปยัง Order ที่ PD ต้องการ',
    category: 'good-issue-order',
    categoryTitle: 'WH - อนุมัติจ่าย',
    logo: BsBootstrapReboot, 
    color: 'fill-amber-100', active: true  
  },
  { 
    title: 'อนุมัติคืน CLAIM',
    path: 'good-reverse-order/claim',
    description: 'ตรวจสอบยอดคืน FG จาก Production',
    category: 'good-reverse-order',
    categoryTitle: 'WH - อนุมัติคืน FG',
    logo: AiOutlineStop, 
    color: 'fill-red-400',
    active: false
  },
  { 
    title: 'อนุมัติคืน REPACK',
    path: 'good-reverse-order/repack',
    description: 'ตรวจสอบยอดคืน FG จาก Production',
    category: 'good-reverse-order',
    categoryTitle: 'WH - อนุมัติคืน FG',
    logo: BsBootstrapReboot, 
    color: 'fill-amber-100',
    active: false
  },
  { 
    title: 'รายการ ORDER CLAIM - เลือก Inspection Form ให้กับ Claim Order',
    path: 'order-claim',
    description: 'เลือก Inspection Form ให้กับ Claim Order',
    category: 'order-claim',
    categoryTitle: 'QC - Claim',
    logo: AiOutlineStop, 
    color: 'fill-red-300', active: true 
  },
  { 
    title: 'ตรวจคุณภาพ FG', path: 'fg-inspection',
    description: 'ตรวจคุณภาพ FG (Filling / Packing)',
    logo: GiMagnifyingGlass, color: ' fill-red-500',
    category: 'fg-inspection', active: true 
  },
  {
    title: 'อนุมัติใบ Receipt', path: 'order-receipt-approval',
    description: 'อนุมัติใบ Receipt สินค้า',
    logo: FcApproval, color: 'fill-rose-400',
    category: 'order-receipt-approval', active: true 
  }
]

export const DepartmentRoles = {
  'Production': ['TeamLeader', 'Checker', 'Leaderline', 'Admin', 'Inspector', 'Reviewer'],
  'Warehouse': ['Inventory', 'Admin'],
  'QC': ['Leaderline', 'Inspector', 'Reviewer', 'Approver', 'Admin'],
  'FA': ['Admin', 'Reviewer', 'Approver', 'Picklist'],
  'PM': ['Leaderline', 'Admin'],
  'IT': ['Leaderline', 'Admin'],
  'PL': ['Leaderline', 'Admin', 'Picklist'],
  'PO': ['Admin'],
  'RD': ['Picklist'],
  'PK': ['Picklist'],
  'QS': ['Reviewer']
}

export const Tags = {
  PARTIAL: 'Partial'
}

export const QCDowntimeCodes = ['180', '188']

export const OrderNoteDisplays = {
  ALL: 'ไม่ระบุ',
  TRIAL_BATCH: 'Trial Batch'
}

export const OrderNotes = {
  ALL: 'ALL',
  TRIAL_BATCH: 'TRIAL_BATCH'
}